import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { VrstaDokumenta } from './vrsta-dokumenta';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-vrsta-dokumenta',
  templateUrl: './vrsta-dokumenta.component.html'
})
export class VrstaDokumentaComponent extends BaseModalContainer<VrstaDokumenta> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaDokumenta>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
